











import { defineComponent, computed } from '@vue/composition-api'
import format from 'nice-bytes'

export default defineComponent({
  props: {
    progressEvent: ProgressEvent
  },

  setup(props) {
    const progress = computed(() => {
      if (props.progressEvent == null) return null

      const proportion = props.progressEvent.loaded / props.progressEvent.total
      const percentage = Math.floor(proportion * 100)
      const total = format(props.progressEvent.total)
      const current = (
        props.progressEvent.loaded / Math.pow(1000, total.magnitude)
      ).toFixed(2)

      return {
        proportion,
        percentage,
        total,
        current
      }
    })

    return {
      progress
    }
  }
})
